module.exports = __webpack_public_path__ + "static/media/inAHurryBike.5cf683df.png";